/**
 * StateBadge — F-005 Phase 4 (IMPL-P4-004).
 *
 * Badge accessibile per stato pratica. Combina background + foreground +
 * icona Lucide (redundant color/icon per WCAG 2.1 AA non solo-colore) e
 * un `aria-label` descrittivo che lo screen reader pronuncia al posto del
 * testo del badge stesso.
 *
 * Single source of truth: `STATO_META` in `../lib/stato-meta`.
 */
import { cn } from '@/lib/utils';
import { STATO_META } from '../lib/stato-meta';
import type { StatoPratica } from '../lib/cliente-pratiche-client';

interface StateBadgeProps {
  stato: StatoPratica;
  className?: string;
}

export function StateBadge({ stato, className }: StateBadgeProps) {
  const meta = STATO_META[stato];
  if (!meta) {
    // Fallback difensivo per stati non ancora mappati (es. nuova enum entry
    // server-side non riflessa qui).
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700',
          className,
        )}
        aria-label={`Stato ${stato}`}
      >
        {stato}
      </span>
    );
  }
  const Icon = meta.icon;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        meta.badgeClass,
        className,
      )}
      aria-label={meta.ariaLabel}
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {meta.label}
    </span>
  );
}
